export default "__VITE_ASSET__CTALlyK$__"